export var venueTypes = {
    INDOOR_ARENA: "Indoor Arena",
    OUTDOOR_STADIUM: "Outdoor Stadium",
    HOCKEY_ARENA: "Hockey Arena",
    FOOTBALL_STADIUM: "Football Stadium"
};
export var venues = [
    {
        id: "DEFAULT",
        name: "Local NY Arena",
        country: "United States",
        city: "New York",
        state: "NY",
        type: venueTypes.HOCKEY_ARENA,
        capacity: 250
    },
    {
        id: "madisonSquareGarden",
        name: "Madison Square Garden",
        country: "United States",
        state: "NY",
        city: "New York",
        type: venueTypes.INDOOR_ARENA,
        capacity: 20000
    },
    {
        id: "tokyoDome",
        name: "Tokyo Dome",
        country: "Japan",
        city: "Tokyo",
        type: venueTypes.INDOOR_ARENA,
        capacity: 55000
    },
    {
        id: "wembleyStadium",
        name: "Wembley Stadium",
        country: "United Kingdom",
        city: "London",
        type: venueTypes.OUTDOOR_STADIUM,
        capacity: 90000
    },
    {
        id: "ataturkOlympicStadium",
        name: "Atat\xfcrk Olympic Stadium",
        country: "Turkey",
        city: "Istanbul",
        type: venueTypes.OUTDOOR_STADIUM,
        capacity: 76092
    },
    {
        id: "maracanaStadium",
        name: "Maracan\xe3 Stadium",
        country: "Brazil",
        city: "Rio de Janeiro",
        type: venueTypes.OUTDOOR_STADIUM,
        capacity: 78000
    },
    {
        id: "rogersCentre",
        name: "Rogers Centre",
        country: "Canada",
        city: "Toronto",
        type: venueTypes.INDOOR_ARENA,
        capacity: 53303
    },
    {
        id: "melbourneCricketGround",
        name: "Melbourne Cricket Ground",
        country: "Australia",
        city: "Melbourne",
        type: venueTypes.OUTDOOR_STADIUM,
        capacity: 100024
    },
    {
        id: "mercedesBenzStadium",
        name: "Mercedes-Benz Stadium",
        country: "United States",
        state: "GA",
        city: "Atlanta",
        type: venueTypes.INDOOR_ARENA,
        capacity: 71000
    },
    {
        id: "stadeDeFrance",
        name: "Stade de France",
        country: "France",
        city: "Saint-Denis",
        type: venueTypes.OUTDOOR_STADIUM,
        capacity: 81338
    },
    {
        id: "beijingNationalStadium",
        name: "Beijing National Stadium",
        country: "China",
        city: "Beijing",
        type: venueTypes.OUTDOOR_STADIUM,
        capacity: 91000
    },
    {
        id: "staplesCenter",
        name: "Staples Center",
        country: "United States",
        state: "CA",
        city: "Los Angeles",
        type: venueTypes.INDOOR_ARENA,
        capacity: 19060
    },
    {
        id: "olympicStadium",
        name: "Olympic Stadium",
        country: "Canada",
        city: "Montreal",
        type: venueTypes.OUTDOOR_STADIUM,
        capacity: 56000
    },
    {
        id: "rodLaverArena",
        name: "Rod Laver Arena",
        country: "Australia",
        city: "Melbourne",
        type: venueTypes.INDOOR_ARENA,
        capacity: 15000
    },
    {
        id: "wrestleManiaStadium",
        name: "WrestleMania Stadium",
        state: "FL",
        country: "United States",
        city: "Tampa",
        type: venueTypes.OUTDOOR_STADIUM,
        capacity: 65000
    },
    {
        id: "o2Arena",
        name: "The O2 Arena",
        country: "United Kingdom",
        city: "London",
        type: venueTypes.INDOOR_ARENA,
        capacity: 20000
    },
    {
        id: "nationalStadium",
        name: "National Stadium",
        country: "Singapore",
        city: "Kallang",
        type: venueTypes.OUTDOOR_STADIUM,
        capacity: 55000
    },
    {
        id: "arenaMexico",
        name: "Arena M\xe9xico",
        country: "Mexico",
        city: "Mexico City",
        type: venueTypes.INDOOR_ARENA,
        capacity: 16000
    },
    {
        id: "allianzArena",
        name: "Allianz Arena",
        country: "Germany",
        city: "Munich",
        type: venueTypes.FOOTBALL_STADIUM,
        capacity: 75000
    },
    {
        id: "saitamaSuperArena",
        name: "Saitama Super Arena",
        country: "Japan",
        city: "Saitama",
        type: venueTypes.INDOOR_ARENA,
        capacity: 37000
    },
    {
        id: "capeTownStadium",
        name: "Cape Town Stadium",
        country: "South Africa",
        city: "Cape Town",
        type: venueTypes.OUTDOOR_STADIUM,
        capacity: 55000
    },
    {
        id: "msgSphere",
        name: "MSG Sphere",
        country: "United States",
        state: "NV",
        city: "Las Vegas",
        type: venueTypes.INDOOR_ARENA,
        capacity: 17500
    },
    {
        id: "birdNestStadium",
        name: "Beijing National Stadium (Bird's Nest)",
        country: "China",
        city: "Beijing",
        type: venueTypes.OUTDOOR_STADIUM,
        capacity: 80000
    },
    {
        id: "prudentialCenter",
        name: "Prudential Center",
        state: "NJ",
        country: "United States",
        city: "Newark",
        type: venueTypes.INDOOR_ARENA,
        capacity: 16500
    },
    {
        id: "bellCentre",
        name: "Bell Centre",
        country: "Canada",
        city: "Montreal",
        type: venueTypes.INDOOR_ARENA,
        capacity: 21500
    },
    {
        id: "sseHydro",
        name: "The SSE Hydro",
        country: "United Kingdom",
        city: "Glasgow",
        type: venueTypes.INDOOR_ARENA,
        capacity: 13000
    },
    {
        id: "marinaBaySands",
        name: "Marina Bay Sands Grand Ballroom",
        country: "Singapore",
        city: "Singapore",
        type: venueTypes.INDOOR_ARENA,
        capacity: 6000
    },
    {
        id: "stadioOlimpico",
        name: "Stadio Olimpico",
        country: "Italy",
        city: "Rome",
        type: venueTypes.OUTDOOR_STADIUM,
        capacity: 70000
    },
    {
        id: "tigerStadium",
        name: "Tiger Stadium",
        country: "United States",
        state: "LA",
        city: "Baton Rouge",
        type: venueTypes.FOOTBALL_STADIUM,
        capacity: 102321
    },
    {
        id: "jyskeBankBoxen",
        name: "Jyske Bank Boxen",
        country: "Denmark",
        city: "Herning",
        type: venueTypes.INDOOR_ARENA,
        capacity: 15000
    },
    {
        id: "marvelStadium",
        name: "Marvel Stadium",
        country: "Australia",
        city: "Melbourne",
        type: venueTypes.OUTDOOR_STADIUM,
        capacity: 56347
    },
    {
        id: "hammersteinBallroom",
        name: "Hammerstein Ballroom",
        country: "United States",
        city: "New York",
        type: venueTypes.INDOOR_ARENA,
        capacity: 3000
    },
    {
        id: "websterHall",
        name: "Webster Hall",
        country: "United States",
        city: "New York",
        type: venueTypes.INDOOR_ARENA,
        capacity: 1500
    },
    {
        id: "barclaysCenter",
        name: "Barclays Center",
        country: "United States",
        state: "NY",
        city: "Brooklyn",
        type: venueTypes.INDOOR_ARENA,
        capacity: 19000
    },
    {
        id: "nassauColiseum",
        name: "Nassau Coliseum",
        state: "NY",
        country: "United States",
        city: "Uniondale",
        type: venueTypes.INDOOR_ARENA,
        capacity: 14740
    },
    {
        id: "westchesterCountyCenter",
        name: "Westchester County Center",
        country: "United States",
        state: "NY",
        city: "White Plains",
        type: venueTypes.INDOOR_ARENA,
        capacity: 5000
    },
    {
        id: "nycbLive",
        name: "NYCB Live, Home of the Nassau Veterans Memorial Coliseum",
        country: "United States",
        state: "NY",
        city: "Uniondale",
        type: venueTypes.INDOOR_ARENA,
        capacity: 13000
    },
    {
        id: "irvingPlaza",
        name: "Irving Plaza",
        country: "United States",
        state: "NY",
        city: "New York",
        type: venueTypes.INDOOR_ARENA,
        capacity: 1100
    },
    {
        id: "stGeorgeTheatre",
        name: "St. George Theatre",
        country: "United States",
        state: "NY",
        city: "Staten Island",
        type: venueTypes.INDOOR_ARENA,
        capacity: 1800
    },
    {
        id: "capitolTheatre",
        name: "Capitol Theatre",
        country: "United States",
        state: "NY",
        city: "Port Chester",
        type: venueTypes.INDOOR_ARENA,
        capacity: 1800
    },
    {
        id: "mulcahysPubAndConcertHall",
        name: "Mulcahy's Pub and Concert Hall",
        country: "United States",
        state: "NY",
        city: "Wantagh",
        type: venueTypes.INDOOR_ARENA,
        capacity: 500
    },
    {
        id: "starlandBallroom",
        name: "Starland Ballroom",
        country: "United States",
        state: "NJ",
        city: "Sayreville",
        type: venueTypes.INDOOR_ARENA,
        capacity: 2100
    },
    {
        id: "paramountTheatre",
        name: "Paramount Theatre",
        country: "United States",
        state: "NY",
        city: "Huntington",
        type: venueTypes.INDOOR_ARENA,
        capacity: 1552
    },
    {
        id: "theWellmontTheater",
        name: "The Wellmont Theater",
        country: "United States",
        state: "NJ",
        city: "Montclair",
        type: venueTypes.INDOOR_ARENA,
        capacity: 2500
    },
    {
        id: "spaceAtWestburyTheater",
        name: "The Space at Westbury Theater",
        country: "United States",
        state: "NY",
        city: "Westbury",
        type: venueTypes.INDOOR_ARENA,
        capacity: 800
    },
    {
        id: "bergenPAC",
        name: "Bergen Performing Arts Center",
        country: "United States",
        state: "NJ",
        city: "Englewood",
        type: venueTypes.INDOOR_ARENA,
        capacity: 1367
    },
    {
        id: "nyackLevonHelmStudio",
        name: "Levon Helm Studio",
        country: "United States",
        state: "NY",
        city: "Woodstock",
        type: venueTypes.INDOOR_ARENA,
        capacity: 200
    },
    {
        id: "wellingtonsPubAndRestaurant",
        name: "Wellington's Pub and Restaurant",
        country: "United States",
        state: "NY",
        city: "Albany",
        type: venueTypes.INDOOR_ARENA,
        capacity: 300
    },
    {
        id: "revolutionBarAndMusicHall",
        name: "Revolution Bar & Music Hall",
        country: "United States",
        state: "NY",
        city: "Amityville",
        type: venueTypes.INDOOR_ARENA,
        capacity: 400
    },
    {
        id: "paramountHudsonValley",
        name: "Paramount Hudson Valley",
        country: "United States",
        state: "NY",
        city: "Peekskill",
        type: venueTypes.INDOOR_ARENA,
        capacity: 1000
    },
    {
        id: "kingAbdullahSportsCity",
        name: "King Abdullah Sports City Stadium",
        country: "Saudi Arabia",
        city: "Jeddah",
        type: venueTypes.OUTDOOR_STADIUM,
        capacity: 62000
    },
    {
        id: "mohammedAbduArena",
        name: "Mohammed Abdu Arena",
        country: "Saudi Arabia",
        city: "Riyadh",
        type: venueTypes.INDOOR_ARENA,
        capacity: 18000
    },
    {
        id: "kingFahdInternationalStadium",
        name: "King Fahd International Stadium",
        country: "Saudi Arabia",
        city: "Riyadh",
        type: venueTypes.OUTDOOR_STADIUM,
        capacity: 68000
    },
    {
        id: "hamadBinKhalifaStadium",
        name: "Hamad bin Khalifa Stadium",
        country: "Qatar",
        city: "Doha",
        type: venueTypes.OUTDOOR_STADIUM,
        capacity: 40000
    },
    {
        id: "zayedSportsCityStadium",
        name: "Zayed Sports City Stadium",
        country: "United Arab Emirates",
        city: "Abu Dhabi",
        type: venueTypes.OUTDOOR_STADIUM,
        capacity: 43000
    },
    {
        id: "dubaiDutyFreeTennisStadium",
        name: "Dubai Duty Free Tennis Stadium",
        country: "United Arab Emirates",
        city: "Dubai",
        type: venueTypes.OUTDOOR_STADIUM,
        capacity: 5000
    },
    {
        id: "cocaColaArena",
        name: "Coca-Cola Arena",
        country: "United Arab Emirates",
        city: "Dubai",
        type: venueTypes.INDOOR_ARENA,
        capacity: 17000
    },
    {
        id: "princeAbdullahAlFaisalStadium",
        name: "Prince Abdullah Al Faisal Stadium",
        country: "Saudi Arabia",
        city: "Jeddah",
        type: venueTypes.OUTDOOR_STADIUM,
        capacity: 38000
    },
    {
        id: "greenHallsStadium",
        name: "Green Halls Stadium",
        country: "Saudi Arabia",
        city: "Riyadh",
        type: venueTypes.INDOOR_ARENA,
        capacity: 5000
    },
    {
        id: "khalifaSportsCityStadium",
        name: "Khalifa Sports City Stadium",
        country: "Bahrain",
        city: "Isa Town",
        type: venueTypes.OUTDOOR_STADIUM,
        capacity: 30000
    },
    {
        id: "kingSaudUniversityStadium",
        name: "King Saud University Stadium",
        country: "Saudi Arabia",
        city: "Riyadh",
        type: venueTypes.OUTDOOR_STADIUM,
        capacity: 25000
    }
];
